import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.24 11a.239.239 0 0 1-.203-.365l3.105-4.97c.256-.41.219-.932-.093-1.3L3.54 1.392A.239.239 0 0 1 3.723 1h1.956c.07 0 .137.031.182.085l1.866 2.21c.778.92.871 2.226.232 3.249l-2.715 4.344a.239.239 0 0 1-.202.112H3.239z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
